/**
 * Create i18n context for custom hook
 */

import { createContext } from 'react'

const I18nContext = createContext({
  changeLanguage: () => {}
})

export default I18nContext
